module.exports = __webpack_public_path__ + "img/06.0779a1c2.png";